import React from "react";
import { Navbar, Container, NavbarBrand  } from 'reactstrap';
import prefeitura_api from "../../api/prefeitura_api.js";

class Navigation extends React.Component{
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);        
        this.state = {
            isOpen: false,
            logotipo: ""
        };
        this.loadLogotipo();
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen            
        });
    }

    loadLogotipo() {
        prefeitura_api.getLogotipo().then(result => {            
            this.setState({
                logotipo: result
            })
        })
    }

    render(){
        return(
            <Navbar expand="sm" className="menu" color="dark">
                <Container>
                    <NavbarBrand><img src={this.state.logotipo} style={{maxHeight:"70px"}}/> </NavbarBrand>
                </Container>
            </Navbar>
        );
    }
}
export default Navigation;